window.lang2 =
{
  "general": {
    "meta": {
      "tags": "Tagged \"{{ tags }}\"",
      "page": "Page {{ page }}"
    },
    "404": {
      "title": "404 Page Not Found",
      "subtext_html": "The page you requested does not exist.",
      "click_here": "Click here",
      "continue_shopping": " to continue shopping."
    },
    "breadcrumbs": {
      "home": "Home",
      "cart": "Shopping cart",
      "home_link_title": "Back to the frontpage"
    },
    "newsletter_form": {
      "newsletter_email": "your-email@example.com",
      "submit": "Submit",
      "newsletter_text": "enter your email address"
    },
    "search": {
      "title": "Search for products on our site",
      "placeholder": "Search",
      "submit": "Search",
      "no_results": "no results",
      "view_results": "See all results"
    },
    "currency": {
      "change_text": "The store's currency changed to",
      "currency": "Currency"
    },
    "language": {
      "language": "Language"
    },
    "sidebar": {
      "sidebar_more": "Sidebar"
    }
  },
  "blogs": {
    "article": {
      "author_on_date_html": "Posted on {{ date }} by {{ author }}",
      "older_post": "Older Post",
      "newer_post": "Newer Post",
      "tags": "Tags",
      "comment_meta_html": "{{ author }} on {{ date }}",
      "read_more": "Read more"
    },
    "comments": {
      "title": "Leave a comment",
      "name": "Your Name",
      "email": "Your Email",
      "message": "Your Comment",
      "post": "Post comment",
      "moderated": "Please note, comments must be approved before they are published",
      "success_moderated": "Your comment was posted successfully. We will publish it in a little while, as our blog is moderated.",
      "success": "Your comment was posted successfully! Thank you!",
      "note": "All blog comments are checked prior to publishing",
      "comments_with_count": {
        "one": "{{ count }} comment",
        "other": "{{ count }} comments"
      }
    },
    "sidebar": {
      "recent_articles": "Recent Articles",
      "tag_cloud": "Tag Cloud",
      "categories": "Categories"
    }
  },
  "cart": {
    "general": {
      "title": "My Cart",
      "remove": "Remove",
      "note": "Special instructions for seller",
      "subtotal": "Subtotal",
      "shipping_at_checkout": "Shipping & taxes calculated at checkout",
      "update": "Update Cart",
      "checkout": "Check Out",
      "button_checkout": "Proceed to Checkout",
      "empty": "Your cart is currently empty.",
      "continue_browsing_html": "Continue browsing <a href=\"\/collections\/all\">here<\/a>.",
      "view_cart": "View Cart",
      "close_cart": "Close",
      "shopping_cart": "Shopping Cart",
      "cart_supermarket": "Cart",
      "label": "Note",
      "label_text": "Additional comments",
      "shipping_calculator_button": "Calculate Shipping",
      "shipping_calculator_calculating": "Calculating...",
      "shipping_calculator_error_message": "Error: Please enter right shipping information",
      "shipping_calculator_success_many_rates": {
        "there_are": "There are",
        "shipping_rates_available_for": "shipping rates available for",
        "starting_at": ", starting at"
      },
      "shipping_calculator_success_one_rate": "There is one shipping rate available for",
      "shipping_calculator_success_no_rate": "There is no shipping rate available for this order and destination.",
      "shipping_calculator_success_at": "at"
    },
    "label": {
      "product": "Products",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "or": "or",
      "quick_cart": "Quick Cart",
      "your_order": "Your order",
      "order_summary": "Order Summary"
    },
    "ajax_cart": {
      "continue_shopping": "Continue Shopping",
      "go_to_cart": "Go to cart",
      "success_text": "is added to your shopping cart.",
      "error": "Error",
      "loading": "Loading",
      "close": "Close",
      "popup_cart_des": "The following items has been added to your cart:",
      "items_in_your_cart": "items in your shopping cart "
    }
  },
  "slideshow": {
    "next_slide": "Next slide",
    "previous_slide": "Previous slide",
    "pause_slideshow": "Pause slideshow",
    "play_slideshow": "Play slideshow",
    "play_video": "Play video",
    "close_video": "Close video"
  },
  "collections": {
    "general": {
      "title": "Collections",
      "no_matches": "Sorry, there are no products in this collection",
      "link_title": "Browse our {{ title }} collection",
      "grid_view": "Grid",
      "list_view": "List",
      "shop_now": "Shop Now",
      "shop_the_collection": "Shop The Collection",
      "show_more": "Show more",
      "no_more_product": "No more product",
      "items_count": {
        "one": "product",
        "other": "products"
      },
      "items_with_count": {
        "one": "{{ count }} product",
        "other": "{{ count }} products"
      }
    },
    "sidebar": {
      "types": "Product Types",
      "vendors": "Vendors",
      "tags": "Tags",
      "clear": "Clear",
      "clear_all": "Clear all",
      "refined_by": "Refine by",
      "sidebar_more": "Refine by"
    },
    "sorting": {
      "title": "Sort by",
      "featured": "Featured",
      "best_selling": "Best Selling",
      "az": "Alphabetically, A-Z",
      "za": "Alphabetically, Z-A",
      "price_ascending": "Price, low to high",
      "price_descending": "Price, high to low",
      "date_descending": "Date, new to old",
      "date_ascending": "Date, old to new"
    },
    "toolbar": {
      "view_as": "View as",
      "item_per_page": "Items Per Page",
      "previous": "Prev",
      "next": "Next",
      "show": "Show",
      "showing": "Showing",
      "all": "All",
      "of": "of"
    }
  },
  "contact": {
    "form": {
      "name": "Your Name",
      "email": "Your Email",
      "address": "Your Address",
      "phone": "Your Phone",
      "message": " Your Comment",
      "placeholder_message": "Please leave your comment here",
      "send": "Send",
      "submit_contact": "Submit Contact",
      "send_question": "Send Question",
      "post_success": "Thanks for contacting us. We'll get back to you as soon as possible."
    }
  },
  "customer": {
    "account": {
      "title": "My Account",
      "details": "Account Details",
      "view_addresses": "View Addresses",
      "return": "Return to Account Details"
    },
    "activate_account": {
      "title": "Activate Account",
      "subtext": "Create your password to activate your account.",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Activate Account",
      "cancel": "Decline Invitation"
    },
    "addresses": {
      "title": "Customer Address Book",
      "default": "Default",
      "add_new": "Add New Address",
      "edit_address": "Edit address",
      "first_name": "First Name",
      "last_name": "Last Name",
      "company": "Company",
      "address1": "Address1",
      "address2": "Address2",
      "city": "City",
      "country": "Country",
      "province": "Province",
      "zip": "Postal\/Zip Code",
      "phone": "Phone",
      "set_default": "Set as default address",
      "add": "Add Address",
      "update": "Update Address",
      "cancel": "Cancel",
      "edit": "Edit",
      "delete": "Remove",
      "delete_message": "Are you sure you wish to delete this address?"
    },
    "logout": {
      "title": "Customer"
    },
    "login": {
      "title": "Customer Login",
      "account": "Account",
      "returning_customer": "Returning Customer",
      "new_customer": "New Customer",
      "email": "Email Address",
      "password": "Password",
      "forgot_password": "Forgot your password?",
      "sign_in": "Sign In",
      "login": "Login",
      "cancel": "Return to Store",
      "guest_title": "Continue as a guest",
      "guest_continue": "Continue"
    },
    "orders": {
      "title": "Order History",
      "order_number": "Order",
      "date": "Date",
      "payment_status": "Payment Status",
      "fulfillment_status": "Fulfillment Status",
      "total": "Total",
      "none": "You haven't placed any orders yet."
    },
    "order": {
      "title": "Order {{ name }}",
      "date": "Placed on {{ date }}",
      "cancelled": "Order Cancelled on {{ date }}",
      "cancelled_reason": "Reason: {{ reason }}",
      "billing_address": "Billing Address",
      "payment_status": "Payment Status",
      "shipping_address": "Shipping Address",
      "fulfillment_status": "Fulfillment Status",
      "discount": "Discount",
      "shipping": "Shipping",
      "tax": "Tax",
      "product": "Product",
      "sku": "SKU",
      "price": "Price",
      "quantity": "Quantity",
      "total": "Total",
      "fulfilled_at": "Fulfilled {{ date }}",
      "subtotal": "Subtotal"
    },
    "recover_password": {
      "title": "Reset your password",
      "email": "Email",
      "submit": "Submit",
      "cancel": "Cancel",
      "subtext": "We will send you an email to reset your password.",
      "success": "We've sent you an email with a link to update your password."
    },
    "reset_password": {
      "title": "Reset account password",
      "subtext": "Enter a new password for {{ email }}",
      "password": "Password",
      "password_confirm": "Confirm Password",
      "submit": "Reset Password"
    },
    "register": {
      "title": "Create An Account",
      "register": "Register",
      "first_name": "First Name",
      "last_name": "Last Name",
      "email": "Your Email Address",
      "password": "Your Password",
      "submit": "Create An Account",
      "cancel": "Return to Store"
    },
    "form": {
      "error_message": "Sorry, looks like something went wrong. Please correct the following and submit again:"
    }
  },
  "home_page": {
    "sections": {
      "frontpage_title": "Frontpage Collection",
      "featured_title": "Featured Collections",
      "news_title": "Latest News"
    },
    "onboarding": {
      "modal_title": "Almost there...",
      "no_products_html": "You have no products in your Frontpage collection. This placeholder will appear until you <a href=\"\/admin\/collections?tutorial=Frontpage\">add a product to this collection<\/a>.",
      "add_product": "Add a Product",
      "product_title": "Example Product Title",
      "no_collections_html": "You don't have any collections to show here. <a href=\"\/admin\/custom_collections\">Add some collections<\/a> to go along with the default Frontpage.",
      "add_collection": "Add a Collection",
      "collection_title": "Example Collection Title"
    },
    "show_more": "Show more",
    "no_more_product": "No more product"
  },
  "layout": {
    "cart": {
      "title": "Cart",
      "items_count": {
        "one": "item",
        "other": "items"
      }
    },
    "customer": {
      "account": "Account",
      "logged_in_as_html": "Logged in as {{ first_name }}",
      "log_out": "Log out",
      "log_in": "Log in",
      "create_account": "Create an account",
      "register": "Register",
      "title": "My Account"
    },
    "footer": {
      "linklist_title": "Quick Links",
      "social_title": "Get Connected",
      "newsletter_title": "Newsletter",
      "accepted_payments": "Accepted Payments"
    }
  },
  "products": {
    "general": {
      "previous_product_html": "&larr; Previous Product",
      "next_product_html": "Next Product &rarr;",
      "from": "From"
    },
    "product": {
      "sale": "Sale",
      "you_save": "You save",
      "custom_label": "Custom Label",
      "bundle_label": "Bundle",
      "new_label": "New",
      "sold_out": "Sold Out",
      "on_sale_from_html": "<strong>On Sale<\/strong> from {{ price }}",
      "unavailable": "Unavailable",
      "compare_at": "Compare at",
      "quantity": "Quantity",
      "add_to_cart": "Add to Cart",
      "add_all_to_cart": "Add all to Cart",
      "buy_now": "Buy Now",
      "add": "Add",
      "select_options": "Select options",
      "quick_view": "Quick View",
      "in_stock": "In stock",
      "out_of_stock": "Out of stock",
      "many_in_stock": "Many in stock",
      "details": "Details",
      "from": "from ",
      "show_options": "Show Variants",
      "hide_options": "Hide Variants",
      "adding": "Adding",
      "thank_you": "Thank You",
      "add_more": "Add More",
      "cart_feedback": "Added",
      "main_product": "This item"
    }
  },
  "gift_cards": {
    "issued": {
      "title": "Here's your {{ value }} gift card for {{ shop }}!",
      "subtext": "Here's your gift card!",
      "disabled": "Disabled",
      "expired": "Expired on {{ expiry }}",
      "active": "Expires on {{ expiry }}",
      "redeem": "Use this code at checkout to redeem your gift card",
      "shop_link": "Start shopping",
      "print": "Print"
    }
  },
  "date_formats": {
    "month_day_year": "%B %d, %Y"
  },
  "wishlist": {
    "general": {
      "my_wishlist": "My Wish Lists",
      "wishlist": "Wish Lists",
      "product_image": "Image",
      "product_name": "Product Name",
      "unit_price": "Price",
      "share_wishlist": "Share my Wishlist Via Email",
      "no_login_html": "To create a wish list you must <a href=\"\/account\/login\">sign in<\/a> or <a href=\"\/account\/register\">create an account<\/a>.",
      "add_to_wishlist": "Add to Wish List",
      "remove_wishlist": "Remove Wish List",
      "note": "Already in your wishlist, Go to wishlist",
      "subtext": "To create a wish list you must",
      "sign_in": "sign in",
      "or": "or",
      "wishlist_empty": "Looks like you haven't started a wishlist yet...",
      "create_account": "create an account"
    }
  }
}